// extracted by mini-css-extract-plugin
module.exports = {"icon":"icons_icon__khoT6","inactive":"icons_inactive__MWYoO","filled":"icons_filled__tF3kj","filledWhite":"icons_filledWhite__mfGlx","raumaSymbol":"icons_raumaSymbol__DJ9R1"};